import React from 'react'

const Separator = () => {
  return (
    <div className='my-4' style={{borderBottom:'1.5px solid #aaa'}}></div>
  )
}

export default Separator